import React from "react";
import { Form, FormInstance } from "antd";
import { IFlowchartGraph } from "@ant-design/flowchart/lib";
import TaskStatusesVisualStore from "../stores/TaskStatusesVisualStore";
import { FlowEditorSelection } from "../types";
import FlowCanvasEditor from "./FlowCanvasEditor";
import FlowEdgeEditor from "./FlowEdgeEditor";
import FlowNodeEditor from "./FlowNodeEditor";
import { FlowMode } from "./TaskStatusFlowEditor.types";

type Props = {
    store: TaskStatusesVisualStore;
    form: FormInstance;
    graph?: IFlowchartGraph;
    selectedItem: FlowEditorSelection;
    flowMode: FlowMode;
    isCustomMode: boolean;
    onReloadGraph: () => void;
};

const TaskStatusFlowPropertiesPanel: React.FC<Props> = ({
    store,
    form,
    graph,
    selectedItem,
    flowMode,
    isCustomMode,
    onReloadGraph,
}) => (
    <div className="flow-properties-panel">
        <p
            style={{
                borderBottom: "1px solid #d9d9d9",
                textAlign: "center",
                padding: "8px 0px",
                flex: "none",
                margin: 0,
                fontWeight: 700,
            }}
        >
            Properties
        </p>
        <div style={{ flex: "auto", overflowX: "hidden", padding: "16px" }}>
            <Form form={form} layout="vertical" className="alpha-form">
                {selectedItem.type === "none" && (
                    <FlowCanvasEditor
                        store={store}
                        flowMode={flowMode}
                        isCustomMode={isCustomMode}
                        onChangeCallback={onReloadGraph}
                    />
                )}
                {selectedItem.type === "edge" && graph && (
                    <FlowEdgeEditor
                        store={store}
                        graph={graph}
                        selection={selectedItem}
                        isCustomMode={isCustomMode}
                    />
                )}
                {selectedItem.type === "node" && (
                    <FlowNodeEditor
                        store={store}
                        selection={selectedItem}
                        isCustomMode={isCustomMode}
                    />
                )}
            </Form>
        </div>
    </div>
);

export default TaskStatusFlowPropertiesPanel;
